export default async function postRedirect(
  urlPath: string,
  payload: Record<string, string>,
) {
  const form = document.createElement("form");

  form.method = "POST";
  form.action = `${import.meta.env.VITE_ROOT_API}/${urlPath}`;

  for (const [key, value] of Object.entries(payload)) {
    const element = document.createElement("input");
    element.name = key;
    element.value = value.toString();
    form.appendChild(element);
  }

  document.body.appendChild(form);

  form.submit();
}
